import { AnyValueGroup } from './any-value-group';
import type { MenuProps } from './types';

export const FileMenu = ({ state, actions }: MenuProps) => {
  return <AnyValueGroup state={state} actions={actions} />;
};
